module.exports = __webpack_public_path__ + "img/maker-8.6007ffe2.jpg";